import type { Identity } from '@icp-sdk/core/agent';

import { HttpAgent } from '@icp-sdk/core/agent';
import { safeGetCanisterEnv } from '@icp-sdk/core/agent/canister-env';

// Ponto único de host + root key para toda instanciação de actor.
// Todo call site deve usar `createIcpAgent`, nunca reimplementar host/agent.
//
// A root key vem do cookie `ic_env` (servido pelo canister de assets em
// produção e pelo dev server do Vite localmente, ver vite.config.ts). Se o
// cookie estiver ausente, `HttpAgent` cai para o root key real da mainnet
// por padrão (`shouldFetchRootKey` default `false`) — falha segura.

export async function createIcpAgent(identity?: Identity): Promise<HttpAgent> {
  const canisterEnv = safeGetCanisterEnv();
  return HttpAgent.create({
    host: window.location.origin,
    identity,
    rootKey: canisterEnv?.IC_ROOT_KEY,
  });
}
